import React, { useMemo } from 'react';
import { DECORACION, NIEVE_COPOS } from '../../config/decoracion';
import './Nieve.css';

// Copos de nieve cayendo sobre todo el sitio (decoración 'invierno').
// 100% por código (sin imágenes). Cada copo tiene tamaño, posición, velocidad
// y vaivén propios para que la caída se vea natural y no "en bloque".
const CARACTERES = ['❄', '❅', '❆', '•', '•']; // ❄ ❅ ❆ • •

const prefersReduced =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const Nieve = () => {
  const copos = useMemo(
    () =>
      Array.from({ length: NIEVE_COPOS }, (_, i) => ({
        id: i,
        left: Math.random() * 100, // % del ancho
        char: CARACTERES[Math.floor(Math.random() * CARACTERES.length)],
        size: 6 + Math.random() * 16, // 6px - 22px
        caida: 7 + Math.random() * 9, // 7s - 16s (los más chicos, más lentos)
        vaiven: 3 + Math.random() * 4, // 3s - 7s de balanceo lateral
        delay: -Math.random() * 16, // desfasados: ya hay nieve cayendo al cargar
        drift: 24 + Math.random() * 64, // px de vaivén horizontal
        opacity: 0.55 + Math.random() * 0.45,
      })),
    []
  );

  if (DECORACION !== 'invierno' || prefersReduced) return null;

  return (
    <div className="nieve" aria-hidden="true">
      {copos.map((c) => (
        <span
          key={c.id}
          className="nieve__copo"
          style={{
            left: `${c.left}%`,
            fontSize: `${c.size}px`,
            opacity: c.opacity,
            animationDuration: `${c.caida}s`,
            animationDelay: `${c.delay}s`,
            '--drift': `${c.drift}px`,
          }}
        >
          <span
            className="nieve__vaiven"
            style={{ animationDuration: `${c.vaiven}s` }}
          >
            {c.char}
          </span>
        </span>
      ))}
    </div>
  );
};

export default Nieve;
